"use client";

// Shared UI primitives for the free-tool calculators.

const inputBase =
  "w-full bg-[#1e1e1e] border-2 border-[#3e3e3e] rounded-lg px-4 py-3 text-[#f8f7f4] text-[16px] focus:outline-none focus:border-[#bbe1e6] transition-colors";

export const Field = ({ label, suffix, value, onChange, min = 0, max, step = 1 }) => (
  <label className="flex flex-col gap-2">
    <span className="text-[14px] text-[#a4a4a4] leading-5">{label}</span>
    <div className="relative">
      <input
        type="number"
        inputMode="decimal"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={inputBase}
      />
      {suffix && (
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[14px] text-[#909090]">
          {suffix}
        </span>
      )}
    </div>
  </label>
);

export const Stat = ({ label, value, highlight }) => (
  <div
    className={`flex flex-col gap-1 rounded-xl p-5 border-2 ${
      highlight
        ? "bg-[#bbe1e6]/10 border-[#bbe1e6]/40"
        : "bg-[#1e1e1e] border-white/10"
    }`}
  >
    <span className="text-[13px] uppercase tracking-[0.1em] text-[#a4a4a4]">
      {label}
    </span>
    <span
      className={`text-[28px] leading-9 tracking-[-0.5px] ${
        highlight ? "text-[#bbe1e6]" : "text-[#f8f7f4]"
      }`}
    >
      {value}
    </span>
  </div>
);

export const fmtMoney = (n) =>
  n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

export const fmtPct = (n, digits = 1) => `${n.toFixed(digits)}%`;
